import Constantes from "./Constantes";

/**
 * Sistema de logging unificado.
 *
 * - Controlado por `Constantes.DEBUG_ENABLED`.
 * - Los datos se serializan a JSON (con indentación) para facilitar
 *   copiar/pegar desde la consola del navegador.
 * - Uso:
 *     import Logger from "Projects/CC_cubi_clan_project/Utils/Logger";
 *     Logger.debug("TEAN", "loadProject", { id: 5, name: "..." });
 *     Logger.warn("SSO", "checkSession", "Token expirado");
 *     Logger.error("CCON", "saveTransaction", error);
 */

const SANITIZE_KEYS = ["imageBase64"];

/**
 * Reemplaza valores pesados (imágenes base64) por un resumen corto
 * para que el JSON sea legible y no desborde la consola.
 */
function sanitize(key, value) {
  if (SANITIZE_KEYS.includes(key) && typeof value === "string" && value.length > 80) {
    return `[base64 ${value.length} chars]`;
  }
  return value;
}

function formatArgs(args) {
  return args.map((a) => {
    if (a === null || a === undefined) return String(a);
    if (typeof a === "object") {
      try {
        return JSON.stringify(a, sanitize, 2);
      } catch {
        return String(a);
      }
    }
    return a;
  });
}

function buildPrefix(app, method) {
  const ts = new Date().toISOString().slice(11, 23);
  return `[${ts}][${app}][${method}]`;
}

const Logger = {
  /**
   * Log de depuración. Solo imprime si DEBUG_ENABLED = true.
   * @param {string} app    - Código de la app (TEAN, SSO, CCON…)
   * @param {string} method - Nombre del método/componente
   * @param {...any}  data  - Datos a loguear (se serializan a JSON)
   */
  debug(app, method, ...data) {
    if (!Constantes.DEBUG_ENABLED) return;
    console.log(buildPrefix(app, method), ...formatArgs(data));
  },

  /**
   * Log de advertencia. Siempre visible.
   */
  warn(app, method, ...data) {
    console.warn(buildPrefix(app, method), ...formatArgs(data));
  },

  /**
   * Log de error. Siempre visible.
   */
  error(app, method, ...data) {
    console.error(buildPrefix(app, method), ...formatArgs(data));
  },
};

export default Logger;
